<template>

    <div class="step-content">
        <div class="intro-block">
            <h5 class="txt-grt">Which content ?</h5>
            <p>Choose the type of content that you want to deliver</p>
        </div>
        <div class="step-inner-content">
        
            <SelectWrapper class="bgr" item="Video On Demand"  v-model="Global.mockupConfig.content.vod"></SelectWrapper>
            <SelectWrapper class="bgr" item="Live 24x7" v-model="Global.mockupConfig.content.live"></SelectWrapper>
            <SelectWrapper class="bgr" item="Live Events" v-model="Global.mockupConfig.content.events"></SelectWrapper>
            <SelectWrapper class="bgr" item="Start Over & Replay" v-model="Global.mockupConfig.content.replay"></SelectWrapper>
            <SelectWrapper class="bgr" item="Podcast" v-model="Global.mockupConfig.content.podcast"></SelectWrapper>

            <div class="nxt-out">
                <div class="bgout"></div>
                <router-link tag="div" to="/infos" class="btn bck">
                    <span class="txt">Back</span>
                </router-link>
                <router-link tag="div" to="/model" class="btn main txt-blk">
                    <span class="hvr"></span>
                    <span class="txt">Continue</span>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import SelectWrapper from '../../components/SelectWrapper'

    export default {

        name: 'B',

        components: {
            SelectWrapper
        },

        data() {
            return {
                Global
            }
        }
    }
</script>